import { render, staticRenderFns } from "./safeCom.vue?vue&type=template&id=747f72ba&scoped=true&"
import script from "./safeCom.vue?vue&type=script&lang=js&"
export * from "./safeCom.vue?vue&type=script&lang=js&"
import style0 from "./safeCom.vue?vue&type=style&index=0&id=747f72ba&scoped=true&lang=css&"
import style1 from "./safeCom.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747f72ba",
  null
  
)

export default component.exports